import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Wishes from "@/pages/Wishes";
import Admin from "@/pages/Admin";
import AddWish from "@/pages/AddWish";
import Bende from "@/pages/Bende";
import BendeMember from "@/pages/BendeMember";
import BendeEdit from "@/pages/BendeEdit";

function App() {
  return (
    <div className="App noise-overlay">
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/de-bende" element={<Bende />} />
            <Route path="/de-bende/:slug" element={<BendeMember />} />
            <Route path="/de-bende/:slug/bewerken" element={<BendeEdit />} />
            <Route path="/wensen" element={<Wishes />} />
            <Route path="/admin" element={<Admin />} />
            {/* Hidden contribute routes - share only with friends */}
            <Route path="/voor-vrienden/wens" element={<AddWish />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
